export interface GetSimpleCollectionRequest {
  collectionNo: string
}

export function GetSimpleCollectionRequestToJSON(
  value: GetSimpleCollectionRequest
): any {
  return {
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined
  }
}
